// 글자수 최대 15자
export const maxLength = (value) => value.length <= 15;
export const maxLengthCheck = (nun, value) => value.length <= nun;
